<div class="row" *ngIf="!loadingComponent; else loading">
  <div class="col-12 col-md-6">
    <div [formGroup]="form">
      <lib-meta-select-input
        formControlName="levsattkod"
        table="x2f"
        metaId="levsattkod"
        metaDisplay="levsattbeskr"
        [renderStatic]="!isRef"
      >
      </lib-meta-select-input>
    </div>
    <div [formGroup]="form">
      <lib-meta-select-input
        formControlName="levvillkkod"
        table="x2e"
        metaId="levvillkkod"
        metaDisplay="levvillkbeskr"
        [renderStatic]="!isRef"
      >
      </lib-meta-select-input>
    </div>
  </div>
  <div class="col-12 col-md-6">
    <div [formGroup]="form">
      <lib-meta-select-input
        formControlName="betkod"
        table="x2"
        metaId="betkod"
        metaDisplay="betvillbeskr"
        [optionsFilterFunction]="filterPaymentTerms.bind(this, customerKusBetkod)"
      >
      </lib-meta-select-input>
    </div>
    <div [formGroup]="form">
      <lib-meta-select-input
        formControlName="saljare"
        table="salj"
        metaId="saljare"
        metaDisplay="saljarenamn"
        [renderStatic]="!isRef"
      >
      </lib-meta-select-input>
    </div>
    <div *ngIf="isCapstone">
      <lib-gung-checkbox-input-horizontal
        gungTranslate="NEW_CUSTOMER_ORDER"
        [(ngModel)]="newCustomerOrder"
      ></lib-gung-checkbox-input-horizontal>
    </div>
  </div>
</div>

<ng-template #loading translate> LOADING </ng-template>
